<template>
  <div class="vs-checkbox-group">
    <input
      :id="id"
      v-model.trim="inputValue"
      type="checkbox"
      class="vs-checkbox"
      :indeterminate.prop="indeterminate"
      :aria-checked="ariaChecked"
    >
    <span
      class="vs-fake-checkbox"
      :class="{ 'vs-checked': value }"
    />
    <label
      :for="id"
      class="vs-label vs-label-checkbox"
    >{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'VsCheckbox',
  props: {
    id: { type: String, default: '' },
    label: { type: String, default: null },
    indeterminate: { type: Boolean, default: false },
    level: { type: String, default: '1' },
    value: { type: Boolean },
  },
  data() {
    return {
      checkboxEl: null,
      checkboxElFocus: false,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ariaChecked: {
      get() {
        return this.indeterminate
          ? 'mixed'
          : this.inputValue
          ? 'true'
          : 'false';
      },
    },
  },
  watch: {
    inputValue(value) {
      this.handleChange(value);
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('onChange', {
        id: this.id,
        level: parseInt(this.level),
        checked: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './checkboxInput';
@import '@/styles/accessibility';
@import '@/styles/core/types/types';
@import '@/styles/label';
</style>
